import React from "react";
import { Link } from "react-router-dom";
import { SiTreehouse } from "react-icons/si";
import { BsFillArrowUpCircleFill } from 'react-icons/bs';
import { FaFacebook, FaTwitterSquare, FaInstagramSquare } from 'react-icons/fa';
import About from "../img/about.jpg";
import team1 from "../img/property-1.jpg";
import CallToAction from "../img/call-to-action.jpg";
import PropertyImg from "../img/team-1.jpg";

const Home = () => {
  return (
    <React.Fragment>
      {/* <!-- Banner Image  --> */}
      <div className="banner-image w-100 d-flex justify-content-center align-items-center">
        <div className="content text-center">
          <h1 className="text-white " style={{fontSize: "40px", fontWeight: "bold"}}>Real Estate <br></br> Sample Design</h1>
        </div>
      </div>

      {/* <!-- Search Start --> */}
      <div
        className="container shadow bg-light mb-5 rounded"
        style={{ padding: "20px", marginTop: "-50px" }}
      >
        <div className="container">
          <div className="row g-2">
            <div className="col-md-10">
              <div className="row g-2">
                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control border-0 py-3"
                    placeholder="Search Keyword"
                  />
                </div>
                <div className="col-md-4">
                  <select className="form-select border-0 py-3">
                    <option>Property Type</option>
                    <option>Property Type 1</option>
                    <option>Property Type 2</option>
                    <option>Property Type 3</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <select className="form-select border-0 py-3">
                    <option>Location</option>
                    <option>Location 1</option>
                    <option>Location 2</option>
                    <option>Location 3</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button className="btn btn-dark border-0 w-100 py-3">
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Search End --> */}

      {/* <!-- Category Start --> */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center mx-auto mb-5" style={{ maxWidth: 600 }}>
            <h1 className="mb-3">Property Types</h1>
            <p>
              Eirmod sed ipsum dolor sit rebum labore magna erat. Tempor ut
              dolore lorem kasd vero ipsum sit eirmod sit. Ipsum diam justo sed
              rebum vero dolor duo.
            </p>
          </div>
          <div className="row g-5">
            <div className="col-lg-4 col-sm-6 p-3">
              <span
                className="d-block bg-white text-center rounded p-3"
                to="#"
              >
                <div className="rounded p-4">
                  <div className="icon mb-3 bg-light" >
                    <SiTreehouse style={{ fontSize: "2rem", color: "blue" }} />
                  </div>
                  <h6>Villa</h6>
                  <span>123 Properties</span>
                </div>
              </span>
            </div>
            <div className="col-lg-4 col-sm-6 ">
              <span
                className="cat-item d-block bg-white text-center rounded p-3"
                to="#"
              >
                <div className="rounded p-4">
                  <div className="icon mb-3 bg-light" >
                    <SiTreehouse style={{ fontSize: "2rem", color: "blue" }} />
                  </div>
                  <h6>Villa</h6>
                  <span>123 Properties</span>
                </div>
              </span>
            </div>
            <div className="col-lg-4 col-sm-6">
              <span
                className="cat-item d-block bg-white text-center rounded p-3"
                to="#"
              >
                <div className="rounded p-4">
                  <div className="icon mb-3 bg-light" >
                    <SiTreehouse style={{ fontSize: "2rem", color: "blue" }} />
                  </div>
                  <h6>Villa</h6>
                  <span>123 Properties</span>
                </div>
              </span>
            </div>
           
          </div>
        </div>
      </div>
      {/* <!-- Category End --> */}

      {/* <!-- About Start --> */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <div className="overflow-hidden">
                <img className="img-fluid w-100" src={About} alt="" />
              </div>
            </div>
            <div className="col-lg-6">
              <h1 className="mb-4">#1 Place To Find The Perfect Property</h1>
              <p className="mb-4">
                Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit.
                Aliqu diam amet diam et eos. Clita erat ipsum et lorem et sit,
                sed stet lorem sit clita duo justo magna dolore erat amet
              </p>
              <p>
                <i className="fa fa-check text-primary me-3" />
                Tempor erat elitr rebum at clita
              </p>
              <p>
                <i className="fa fa-check text-primary me-3" />
                Aliqu diam amet diam et eos
              </p>
              <p>
                <i className="fa fa-check text-primary me-3" />
                Clita duo justo magna dolore erat amet
              </p>
              <a className="btn btn-primary py-3 px-5 mt-3" href>
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- About End --> */}
          

        {/* <!-- Property List Start --> */}
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center mx-auto mb-5" style={{maxWidth: 600}}>
                <h1 className="mb-3">Property Listing</h1>
                <p>Eirmod sed ipsum dolor sit rebum labore magna erat. Tempor ut dolore lorem kasd vero ipsum sit eirmod sit. Ipsum diam justo sed rebum vero dolor duo.</p>
                </div>
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="team-item rounded overflow-hidden">
                        <div className="position-relative">
                            <img className="img-fluid" src={team1} alt='' />
                            <div className="bg-primary rounded text-white position-absolute start-0 top-0 m-1 py-1 px-3">
                              For Sell
                            </div>
                        </div>
                        <div className="text-center p-4 mt-3">
                            <h5 className="fw-bold mb-0">Full Name</h5>
                            <small>Designation</small>
                        </div>
                        
                        <div className="d-flex border-top">
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-ruler-combined text-primary me-2" />
                    1000 Sqft
                  </small>
                  <small className="flex-fill text-center border-end py-2">
                    <i className="fa fa-bed text-primary me-2" />3 Bed
                  </small>
                  <small className="flex-fill text-center py-2">
                    <i className="fa fa-bath text-primary me-2" />2 Bath
                  </small>
                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      {/* <!-- Property List End --> */}
      
        {/* <!-- Call to Action Start --> */}
        <div className="container-xxl py-5">
            <div className="container">
                <div className="">
                  <div className="bg-white rounded p-4" style={{border: '1px dashed rgba(0, 185, 142, .3)'}}>
                      <div className="row g-5 align-items-center">
                      <div className="col-lg-6">
                          <img className="img-fluid rounded w-100" src={CallToAction} alt='' />
                      </div>
                      <div className="col-lg-6">
                          <div className="mb-4">
                          <h1 className="mb-3">Contact With Our Certified Agent</h1>
                          <p>Eirmod sed ipsum dolor sit rebum magna erat. Tempor lorem kasd vero ipsum sit sit diam justo sed vero dolor duo.</p>
                          </div>
                          <Link to='' className="btn btn-primary py-3 px-4 me-2"><i className="fa fa-phone-alt me-2" />Make A Call</Link>
                          <Link to='' className="btn btn-dark py-3 px-4"><i className="fa fa-calendar-alt me-2" />Get Appoinment</Link>
                      </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>
        {/* <!-- Call to Action End --> */}



        {/* <!-- Back to Top --> */}
        <Link to="#" className="btn btn-lg btn-primary btn-lg-square back-to-top"><BsFillArrowUpCircleFill/></Link>
    </React.Fragment>
  );
};

export default Home;
